<template>
	<div class="main">网络错误，请重新刷新本页！</div>
</template>

<script>
	import {
		login,
		PROtype
	} from "../utils/request.js";
	import {
		Setitem,
		Getitem
	} from "../utils/item.js";
	export default {
		methods: {
			async Slogin() {
				let s = await Getitem("user");
				if (s && s !== "") {
					// console.log('执不执行');
					try {
						await this.Spro()
						this.$router.push("/");
					} catch (error) {
						this.$toast.error("获取数据失败");
					}
				} else {
					try {
						const res = await templogin();
						// console.log(res);
						if (res.code === 200) {
							await this.Spro()
							this.$router.push("/");
						} else {
							this.$toast.error(res.msg);
						}
					} catch (error) {
						this.$toast.error("网络错误");
					}
				}
			},
			async Spro() {
				try {
					const res = await PROtype();
					if (res.code === 200) {
						let list = res.list;
						let setkeylist = list.map((res) => res.intent);
						let keylist = [...new Set(setkeylist)];
						let newlist = [];

						keylist.forEach((r) => {
							let s = {
								name: r,
								list: [],
							};
							const filteredList = list.filter((s) => s.intent === r);
							s.list = filteredList;
							newlist.push(s);
						});
						Setitem("setmenu", newlist)
					} else {
						throw new Error("网络错误");
					}
				} catch (error) {
					throw error;
				}
			}
		},
		async created() {
			await this.Slogin()
		},
		watch: {},
	};
</script>

<style lang="less" scoped>
	.main {
		position: absolute;
		top: 50%;
		left: 50%;
	}
</style>